<template>
  <v-select color='primary' class='LanguageSwitcher ma-0' label='Idioma' :items='items' item-value='code'
            item-text='language' v-model='lang' solo outline @change='changeLanguage' ref='switcher' dark
            v-if='$props.dark !== undefined'></v-select>

  <v-select color='primary' class='LanguageSwitcher ma-0' label='Idioma' :items='items' item-value='code'
            item-text='language' v-model='lang' solo outline @change='changeLanguage' ref='switcher' v-else></v-select>
</template>

<script>
import { Trans } from '@/plugins/Translation';
import { SUPPORTED_LANGUAGES } from '@/constants/trans';

import { loadLanguageAsync } from '@/plugins/i18n';

export default {
  props: {
    dark: String
  },
  data() {
    return {
      lang: Trans.currentLanguage
    };
  },
  computed: {
    supportedLanguagesCode() {
      return Trans.supportedLanguagesCode;
    },
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    items() {
      return SUPPORTED_LANGUAGES;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    }
  },
  mounted() {
  },
  methods: {
    changeLanguage(lang) {
      this.$cookies.set('lang', lang, Infinity);
      loadLanguageAsync(lang);
    },
    isCurrentLanguage(lang) {
      return lang === this.currentLanguage;
    }
  }
};
</script>

<style lang='scss'>
.LanguageSwitcher {
  display: block;
  flex: none;
  width: 220px;
  z-index: 9999;

  .v-input__control {
    min-height: auto;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__slot {
    min-height: auto;
    margin: 0;
    box-shadow: none !important;
  }

  &.theme--light {
    .v-input__slot {
      border: 2px solid rgba(0, 0, 0, .24);
    }

    &:hover {
      .v-input__slot {
        border: 2px solid rgb(219, 59, 81) !important;
      }
    }
  }
}
</style>
